import { render } from "./StafetProfileForm.vue?vue&type=template&id=5eb67b62"
import script from "./StafetProfileForm.vue?vue&type=script&lang=js"
export * from "./StafetProfileForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__